import React, { useRef, useState } from "react";
import ReactDOM from 'react-dom';
import LiveDraftTooltip from "./LIveDraftTooltip";
import { Link } from "react-router-dom";
import { PRODUCT_TYPE_CHILD, PRODUCT_TYPE_PARENT, PRODUCT_TYPE_PRODUCT } from "Pages/GMS/Products/constants";

type TLiveDraftButtonProps = {
    item?: any;
    handleChange?: Function;
    selected?: string;
    type?: 'id' | 'product';
}

const LiveDraftButton = ({
    item,
    handleChange,
    selected = "draft",
    type = 'id'
}: TLiveDraftButtonProps) => {
    const [showTooltip, setShowTooltip] = useState<[boolean, string|null]>([false, null]);
    const divRef = useRef<HTMLDivElement>(null);
    const tooltipRef = useRef<HTMLDivElement>(null);

    const portalRoot = document.getElementById('tooltip-portal') as HTMLDivElement;

    const handleClose = (e: React.MouseEvent<any>) => {
        // setShowTooltip([false, null])
    };

    if (type === 'id') {
        return (
            <div
                ref={divRef}
                onMouseLeave={() => setShowTooltip([false, null])}
                onMouseEnter={() => setShowTooltip([true, null])} 
                className={`tw-rounded tw-bg-[#EEEEEF] tw-p-0.5 tw-px-2.5 tw-text-xs tw-cursor-pointer`}
            >
                <span>ID</span>
                {showTooltip[0] &&
                    ReactDOM.createPortal(
                        <LiveDraftTooltip 
                            ref={tooltipRef}
                            id={item.id}
                            relativeRef={divRef.current as HTMLDivElement}
                            handleClose={handleClose}
                            label="UID"
                        />,
                        portalRoot
                    )
                }
            </div>
        );
    }

    return (
        <div
            ref={divRef}
            onMouseLeave={() => setShowTooltip([false, null])}
            onMouseEnter={() => setShowTooltip([true, null])} 
            className={`${(item.product_type === PRODUCT_TYPE_PRODUCT || item.product_type === PRODUCT_TYPE_CHILD) ? "tw-text-[#0747A6]" : ""} tw-truncate tw-max-w-full tw-block tw-overflow-hidden`}
        >
            <Link to={item.product_type !== PRODUCT_TYPE_PARENT ? `/gms/product/details/${item.id}` : "#"}>
                {item.name}
            </Link>
            {showTooltip[0] &&
                ReactDOM.createPortal(
                    <LiveDraftTooltip 
                        ref={tooltipRef}
                        id={item.name}
                        relativeRef={divRef.current as HTMLDivElement}
                        handleClose={handleClose}
                        label="ProductName"
                    />,
                    portalRoot
                )
            }
        </div>
    );
};

export default LiveDraftButton;

// const [select, setSelect ] = useState(false)

// const labels = [
    //     {label: "Live", value: "live", color: "#95F492"},
    //     {label: "Draft", value: "draft", color: "#C3C8D9"},
    //     {label: "Rollback", value: "rollback", color: "#FBD755"},
    // ]

// for products
    // if (item.product_type === PRODUCT_TYPE_PRODUCT) return (
    //     <div className={`tw-flex tw-rounded tw-bg-[#7676801F] tw-p-0.5 tw-w-min tw-justify-between`}ref = {divRef}>
    //     {labels.map((label, index) => (
    //         <button 
    //             key={index}
    //             className={`${
    //                 label.value === selected
    //                 ? ' tw-bg-white tw-text-xs tw-font-normal tw-text-gray-900 tw-shadow-md'
    //                 : ' tw-bg-transparent tw-text-xs tw-font-normal tw-text-gray-500'
    //             } tw-flex tw-px-3.5 tw-py-1 rounded-l tw-rounded tw-transition-all tw-duration-300 tw-ease-in-out tw-space-x-1 tw-items-center`}
    //             onClick={() => handleChange && handleChange(item, label.value)}
    //             onMouseEnter={() => setShowTooltip([true, label.value])}
    //             onMouseLeave={() => setShowTooltip([false, null])} 
    //         >
    //             <span className={`tw-w-2.5 tw-h-2.5 tw-block tw-rounded-sm`} style = {{background: label.color}}/>
    //             { label.value === selected && <span>{label.label}</span> }
    //             {
    //                 showTooltip[0] && showTooltip[1] === label.value && 
    //                     ReactDOM.createPortal(
    //                     <LiveDraftTooltip ref={tootipRef} color = {label.color} label = {label.label} id = {item.id} relativeRef={divRef.current as HTMLDivElement} handleClose={handleClose}/>
    //                     ,portalRoot
    //                 )
    //             }
    //         </button>
    //     ))}
    //     </div>
    // )
    
    // return (<></>)